/* @flow */

import * as React from 'react';

type Props = {
  children: React.Node,
};

const BaseNotification = ({ children }: Props): React.Node => <>{children}</>;

export default React.memo<Props>(BaseNotification);
